export const IS_DEV = process.env.NEXT_PUBLIC_APP_ENV === 'development'
export const IS_TEST = process.env.NEXT_PUBLIC_APP_ENV === 'test'
export const IS_PROD = process.env.NEXT_PUBLIC_APP_ENV === 'production'
export const IS_PREVIEW = process.env.NEXT_PUBLIC_PREVIEW === 'true'
export const IS_ANALYZE = process.env.NEXT_PUBLIC_ANALYZE === 'true'
export const IS_LOCAL = IS_DEV || IS_PREVIEW

export function isBrowser() {
  return typeof window !== 'undefined'
}
